export default {
    setIndexCompany(state, data){
        state.allCompanies = data;
    },
    setShowCompany(state, data){
        state.companyShow = data;
    },
}